(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-focus-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-lightbox-trigger]');
  if (trigger) {
    var modal = trigger.closest('section').querySelector('[data-lightbox-modal]');
    if (!modal) return;
    modal.querySelector('.image-lightbox__img').src = trigger.getAttribute('data-lightbox-src');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    return;
  }
  var close = e.target.closest('[data-lightbox-close]');
  if (close) {
    var modal = close.closest('[data-lightbox-modal]');
    modal.hidden = true;
    modal.querySelector('.image-lightbox__img').src = '';
    document.body.style.overflow = '';
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('[data-lightbox-modal]:not([hidden])').forEach(function (modal) {
      modal.hidden = true;
      modal.querySelector('.image-lightbox__img').src = '';
      document.body.style.overflow = '';
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.press-gallery').forEach(function (gallery) {
  var track = gallery.querySelector('.press-gallery__track');
  var slides = gallery.querySelectorAll('.press-gallery__slide');
  var index = 0;

  function update() {
    track.style.transform = 'translateX(' + (-index * 100) + '%)';
  }

  gallery.querySelector('.press-gallery__arrow--next').addEventListener('click', function () {
    index = (index + 1) % slides.length;
    update();
  });

  gallery.querySelector('.press-gallery__arrow--prev').addEventListener('click', function () {
    index = (index - 1 + slides.length) % slides.length;
    update();
  });
});

  } catch(e) { console.error(e); }
})();
})();
